import type {Mapper} from '@automapper/core';
import {UserProfileDownloadServerStrategy, type UserProfileViewModelKeys} from '@igp/shared/features/user-profile';
import {ContainerFacade} from '@igp/shared/ioc-container';
import type {IDownloadStrategy} from '@igp/shared/redux/download';

import {ServiceTypes} from '@ioc-container';

import {userProfileServiceTypes} from './constants';

export class UserProfileContainerFacade extends ContainerFacade {
    bindAll() {
        this._container
            .bind<IDownloadStrategy<UserProfileViewModelKeys>>(userProfileServiceTypes.downloadServerStrategy)
            .toDynamicValue(
                context =>
                    new UserProfileDownloadServerStrategy(
                        context.get<Mapper>(ServiceTypes.AutoMapper),
                        context.get(ServiceTypes.UserProfileService)
                    )
            );
    }
}
